module.exports = __webpack_public_path__ + "img/slim.eedbbd83.png";